export default "__VITE_ASSET__01902983__"